<template>
  <transition name="update-snackbar-slide">
    <div v-if="show" class="update-snackbar" dir="rtl" role="status">
      <span class="update-snackbar__text">نسخه جدید سامانه آماده است</span>

      <div class="update-snackbar__actions">
        <button
          type="button"
          class="update-snackbar__btn update-snackbar__btn--later"
          :disabled="updating"
          @click="later"
        >
          بعداً
        </button>
        <button
          type="button"
          class="update-snackbar__btn update-snackbar__btn--update"
          :disabled="updating"
          @click="update"
        >
          {{ updating ? "در حال بروزرسانی…" : "بروزرسانی" }}
        </button>
      </div>
    </div>
  </transition>
</template>

<script>
import { EventBus } from "@/plugins/eventBus";
import { swState, applyUpdate } from "@/registerServiceWorker";

export default {
  name: "UpdateSnackbar",
  data() {
    return {
      show: false,
      updating: false,
    };
  },
  computed: {
    hasPendingUpdate() {
      return Boolean(swState.registration && swState.registration.waiting);
    },
  },
  created() {
    EventBus.$on("sw-updated", this.onUpdated);
    EventBus.$on("user-logged-in", this.onLogin);
    // اگر رویداد پیش از ساخته شدن این کامپوننت رخ داده باشد
    if (this.hasPendingUpdate) this.show = true;
  },
  beforeDestroy() {
    EventBus.$off("sw-updated", this.onUpdated);
    EventBus.$off("user-logged-in", this.onLogin);
  },
  methods: {
    onUpdated() {
      this.show = true;
    },
    onLogin() {
      // «بعداً» فقط تا ورود بعدی پیغام را پنهان می‌کند
      if (this.hasPendingUpdate) this.show = true;
    },
    update() {
      this.updating = true;
      applyUpdate();
    },
    later() {
      this.show = false;
    },
  },
};
</script>

<style lang="scss" scoped>
/* این کامپوننت بیرون از <v-app> رندر می‌شود، پس نباید به کلاس‌های */
/* اسکوپ‌شده‌ی Vuetify (‎.v-application .primary‎ و…) وابسته باشد. */
.update-snackbar {
  position: fixed;
  bottom: 16px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1000;

  display: flex;
  align-items: center;
  gap: 16px;
  max-width: calc(100vw - 32px);

  padding: 10px 16px;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2), 0 6px 10px rgba(0, 0, 0, 0.14);

  font-family: inherit;
  font-size: 0.875rem;
  color: #424242;
}

.update-snackbar__text {
  white-space: nowrap;
}

.update-snackbar__actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.update-snackbar__btn {
  font-family: inherit;
  font-size: 0.8125rem;
  font-weight: 500;
  padding: 6px 14px;
  border-radius: 4px;
  cursor: pointer;
  border: none;
  transition: opacity 0.2s ease, background-color 0.2s ease;

  &:disabled {
    opacity: 0.6;
    cursor: default;
  }
}

.update-snackbar__btn--update {
  background: #007bff; // همان primary تم برنامه
  color: #ffffff;

  &:hover:not(:disabled) {
    background: #0069d9;
  }
}

.update-snackbar__btn--later {
  background: transparent;
  color: #616161;

  &:hover:not(:disabled) {
    background: rgba(0, 0, 0, 0.06);
  }
}

.update-snackbar-slide-enter-active,
.update-snackbar-slide-leave-active {
  transition: transform 0.25s ease, opacity 0.25s ease;
}

.update-snackbar-slide-enter,
.update-snackbar-slide-leave-to {
  opacity: 0;
  transform: translate(-50%, 24px);
}

@media (max-width: 480px) {
  .update-snackbar {
    left: 16px;
    right: 16px;
    transform: none;
    justify-content: space-between;
  }

  .update-snackbar-slide-enter,
  .update-snackbar-slide-leave-to {
    transform: translateY(24px);
  }
}
</style>
